import '@taterer/rx-jsx'
import App from './App'

document.getElementById('root')!.appendChild(<App />);
